import styled from '@emotion/styled';
import { EnhancedSelect as _EnhancedSelect } from 'common/components/EnhancedSelect/EnhancedSelect';

export const SContainer = styled.div`
  width: 306px;
  padding: 13px;
`;

export const STitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
`;

export const SEnhancedSelect = styled(_EnhancedSelect)<{ currencySelect?: boolean }>`
  width: 100%;
  .ant-select-selection-placeholder {
    ${({ currencySelect }): string | boolean | undefined => currencySelect && `font-size: 8px;`}
  }
`;
